/* eslint-disable no-array-constructor */
/* eslint-disable no-extend-native */
import React from "react";
import { HashRouter as Router, Route, Switch, Redirect } from "react-router-dom";
import Routes from "./routes"
import PrivateRoute from "./components/PrivateRoute/privateRoute"
import "./App.css"
import config from "./config";
import DataStore from "./utils/db";
import { getRemember, clearRemember, clearRememberUser } from "./utils/Session";
import EventEmitter from 'wolfy87-eventemitter';
import pinyin from "pinyin";
import moment from "moment";

import Login from "./pages/login";

import Net from "./utils/net";

global.users = [];
global.UserRole = [];
global.courseTypes = [];
global.courseList = [];
global.packageList = [];

global.PinYin = function (str) {
	if (str == null || str === "")
		return "";
	try {
		var py = pinyin(str, {
			style: pinyin.STYLE_FIRST_LETTER, // 设置拼音风格
			heteronym: false
		}); //首字母
		var ret = "";
		for (var i = 0; i < py.length; i++) {
			ret += py[i][0];
		}
		return ret;
	} catch (e) {
		return str;
	}
};

global.PinYinLong = function (zhStr) {
	if (zhStr == null || zhStr === "")
		return '';
	try {
		var py = pinyin(zhStr, {
			style: pinyin.STYLE_NORMAL, // 设置拼音风格 
			heteronym: true
		}); //首字母
		var str = '';
		for (var i = 0; i < py.length; i++) {
			str += py[i][0];
		}
		return str
	} catch (e) {
		return zhStr;
	}
}

global.getFileType = (suffix) => {
	let type = "";
	if (suffix) {
		suffix = suffix.toLowerCase();
	}
	if (suffix === "mp3" || suffix === "wav") {
		type = "audio";
	} else if (suffix === "mp4" || suffix === "ogg" || suffix === "webm") {
		type = "video";
	} else if (suffix === "jpg" || suffix === "jpeg" || suffix === "png") {
		type = "picture";
	} else if (suffix === "txt") {
		type = "document";
	} else if (suffix === "ppt" || suffix === "pptx") {
		type = "ppt";
	} else if (suffix === "xls" || suffix === "xlsx") {
		type = "xlsx";
	} else if (suffix === "doc" || suffix === "docx") {
		type = "doc";
	} else if (suffix === "pdf") {
		type = "pdf";
	} else if (suffix === "zip" || suffix === "rar") {
		type = "zip";
	}
	return type;
};


global.getFileFormat = (format) => {
	let type = 'OTHER';
	if (format === "mp3" || format === "wav") {
		type = "AUDIO";
	} else if (format === "mp4" || format === "ogg" || format === "webm") {
		type = "VIDEO";
	} else if (format === "jpg" || format === "jpeg" || format === "png") {
		type = "PICTURE";
	} else if (format === "txt"
	) {
		type = "DOCUMENT";
	} else if (format === "ppt" || format === "pptx") {
		type = "PPT";
	} else if (format === "xls" || format === "xlsx") {
		type = "XLS";
	} else if (format === "doc" || format === "docx") {
		type = "DOC";
	} else if (format === "pdf") {
		type = "PDF";
	} else if (format === "zip" || format === "rar") {
		type = "ZIP";
	} else if (format === "usdz") {
		type = "AR";
	}
	return type;
};
global.delParam = (paramKey) => {
	var url = window.location.href;    //页面url
	var urlParam = window.location.search.substr(1);   //页面参数
	var beforeUrl = url.substr(0, url.indexOf("?"));   //页面主地址（参数之前地址）
	var nextUrl = "";

	var arr = new Array();
	if (urlParam != "") {
		var urlParamArr = urlParam.split("&"); //将参数按照&符分成数组
		for (var i = 0; i < urlParamArr.length; i++) {
			var paramArr = urlParamArr[i].split("="); //将参数键，值拆开
			//如果键雨要删除的不一致，则加入到参数中
			if (paramArr[0] != paramKey) {
				arr.push(urlParamArr[i]);
			}
		}
	}
	if (arr.length > 0) {
		nextUrl = "?" + arr.join("&");
	}
	url = beforeUrl + nextUrl;
	return url;
};

function accDiv(arg1, arg2) {
	let t1 = 0, t2 = 0, t3 = 0, r1, r2;
	try {
		t1 = arg1.toString().split(".")[1].length
	} catch (e) {
	}
	try {
		t2 = arg2.toString().split(".")[1].length
	} catch (e) {
	}
	r1 = Number(arg1.toString().replace(".", ""));
	r2 = Number(arg2.toString().replace(".", ""));
	if (r2 === 0)
		return 0;
	let result = String(r1 / r2);
	try {
		t3 = result.toString().split(".")[1].length
	} catch (e) {
	}
	let index = t2 - t1 - t3;
	if (index < 0) {
		result = result.replace(".", "");
		while (result.length <= Math.abs(index)) {
			result = '0' + result;
		}
		let start = result.substring(0, result.length + index);
		let end = result.substring(result.length + index, result.length);
		result = start + '.' + end;
		return Number(result);
	} else if (index > 0) {
		result = result.replace(".", "");
		while (result.length <= Math.abs(index)) {
			result += '0';
		}
		return Number(result);
	} else return Number(result.replace(".", ""));
}

//给Number类型增加一个div方法，调用起来更加方便。
//除法
Number.prototype.div = function (arg) {
	return accDiv(this, arg);
};

function accMul(arg1, arg2) {
	let m = 0, s1 = arg1.toString(), s2 = arg2.toString();
	try {
		m += s1.split(".")[1].length
	} catch (e) {
	}
	try {
		m += s2.split(".")[1].length
	} catch (e) {
	}
	return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m)

}

// 乘法
Number.prototype.mul = function (arg) {
	return accMul(arg, this);
};

function accAdd(arg1, arg2) {
	let r1, r2, m, c;
	try {
		r1 = arg1.toString().split(".")[1].length
	} catch (e) {
		r1 = 0
	}
	try {
		r2 = arg2.toString().split(".")[1].length
	} catch (e) {
		r2 = 0
	}
	c = Math.abs(r1 - r2);
	m = Math.pow(10, Math.max(r1, r2));
	if (c > 0) {
		let cm = Math.pow(10, c);
		if (r1 > r2) {
			arg1 = Number(arg1.toString().replace(".", ""));
			arg2 = Number(arg2.toString().replace(".", "")) * cm;
		} else {
			arg1 = Number(arg1.toString().replace(".", "")) * cm;
			arg2 = Number(arg2.toString().replace(".", ""));
		}
	} else {
		arg1 = Number(arg1.toString().replace(".", ""));
		arg2 = Number(arg2.toString().replace(".", ""));
	}
	return (arg1 + arg2) / m

}

// 加法
Number.prototype.add = function (arg) {
	return accAdd(arg, this);
};

//减法函数，用来得到精确的减法结果     
// 说明：javascript的减法结果会有误差，在两个浮点数相加的时候会比较明显。这个函数返回较为精确的减法结果。     
// 调用：accSub(arg1,arg2)     
// 返回值：arg1减去arg2的精确结果         
function accSub(arg1, arg2) {
	let r1, r2, m, n;
	try {
		r1 = arg1.toString().split(".")[1].length
	} catch (e) {
		r1 = 0
	}
	try {
		r2 = arg2.toString().split(".")[1].length
	} catch (e) {
		r2 = 0
	}
	m = Math.pow(10, Math.max(r1, r2));
	//last modify by deeka      
	// 动态控制精度长度      
	n = (r1 >= r2) ? r1 : r2;
	return Number(((arg2 * m - arg1 * m) / m).toFixed(n));
}

//给Number类型增加一个add方法，调用起来更加方便。     
Number.prototype.sub = function (arg) {
	return accSub(arg, this);
};

global.discriCard = function (UUserCard) {
	// UUserCard = UUserCard.substring(6, 10) + "-" + UUserCard.substring(10, 12) + "-" + UUserCard.substring(12, 14);
	let sex;
	//获取性别 
	if (parseInt(UUserCard.substr(16, 1)) % 2 == 1) {
		//是男则执行代码 ... 
		console.log("男")
		sex = "男";
	} else {
		//是女则执行代码 ... 
		console.log("女")
		sex = "女";
	}
	//获取年龄 
	var myDate = new Date();
	var month = myDate.getMonth() + 1;
	var day = myDate.getDate();
	var age = myDate.getFullYear() - UUserCard.substring(6, 10) - 1;
	if (UUserCard.substring(10, 12) < month || UUserCard.substring(10, 12) == month && UUserCard.substring(12, 14) <= day) {
		age++;
	}
	return { sex, age };
}

global.isCardNo = function (card) {
	// 身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X
	let reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
	if (reg.test(card) === false) {
		return false;
	}
	return true;
}
global.clone = (plainObj) => {
	let cloneObj = {};
	for (let key in plainObj) {
		cloneObj[key] = plainObj[key];
	}
	return cloneObj;
};

global.dateFormat = function (date, format) {
	console.log("dateFormat", date)
	if (!date) {
		return null;
	}
	if (global.isStringType(date)) {
		if (format)
			return moment(date).format(format);
		else
			return moment(date);
	} else {
		if (format)
			return date.format(format);
		else
			return date;
	}
}

global.isStringType = function (val) {
	return typeof val === "string";
}

global.getZero = function (length) {
	if (length <= 0) {
		return "";
	}
	let str = "";
	for (let i = 0; i < length; i++) {
		str += "0";
	}
	return str;
}

global.getDataById = function (array, id) {
	for (let i = 0; i < array.length; i++) {
		const element = array[i];
		if (element._id === id) {
			return element;
		}
	}
	return null;
};

global.getDataByCode = function (array, code) {
	for (let i = 0; i < array.length; i++) {
		const element = array[i];
		if (element.code === code) {
			return element;
		}
	}
	return null;
};

global.isAdmin = function (user) {
	if (user && user.roleCode === "XITONGGUANLIYUAN") {
		return true;
	}
	return false;
};

global.isDev = process && process.env.NODE_ENV === 'development';

let connectingTime = 0;

class App extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
		};
		global.sendMsg = this.sendMsg.bind(this);
		global.connectWs = this.connectWs.bind(this);
		global.getBaseInfo = this.getBaseInfo.bind(this);
		global.loadAllUser = this.loadAllUser.bind(this);
		global.loadUserRole = this.loadUserRole.bind(this);
		global.loadCourseType = this.loadCourseType.bind(this);
		global.loadPackages = this.loadPackages.bind(this);
	};
	UNSAFE_componentWillMount() {
		global.EE = new EventEmitter();
		const baseUrl = global.isDev ? config.baseUrl.dev : config.baseUrl.pro;
		const baseFileUrl = global.isDev ? config.baseFileUrl.dev : config.baseFileUrl.pro;

		console.log("baseUrl" + baseUrl);

		DataStore.BaseUrl = baseUrl;
		global.ServerUrl = baseUrl;
		global.BaseFileUrl = baseFileUrl;

		console.log('window.location', window.location);
		let rememberMe = getRemember();
		console.log('rememberMe', rememberMe);
		if (rememberMe) {
			if (rememberMe.autoLoginTime) {
				let nowTime = new Date().getTime();
				let stamp = nowTime - rememberMe.autoLoginTime;
				let dayCount = stamp / (24 * 60 * 60 * 1000);
				console.log('dayCount', dayCount);
				if (dayCount > 7) {
					console.log("dayCount > 7 goToLogin");
					this.goToLogin();
				} else {
					if (rememberMe.autoLogin) {
						global.loginUser = rememberMe.user;
						Net.post(global.ServerUrl + 'user/token', { token: global.loginUser.token }, res => {
							if (res.ret) {
								global.loginUser = res.ret;
							} else {
								this.goToLogin();
							}
						});
					} else {
						console.log("!rememberMe.autoLogin goToLogin");
						this.goToLogin();
					}
				}
			}
		} else {
			if (!global.loginUser) {
				console.log("!rememberMe goToLogin");
				this.goToLogin();
			}
		}
		// console.log("app.js UNSAFE_componentWillMount loginUser", global.loginUser);
	}

	componentDidMount() {
		global.EE = new EventEmitter();
		const baseUrl = global.isDev ? config.baseUrl.dev : config.baseUrl.pro;
		const baseFileUrl = global.isDev ? config.baseFileUrl.dev : config.baseFileUrl.pro;
		const templateUrl = global.isDev ? config.templateUrl.dev : config.templateUrl.pro;
		DataStore.BaseUrl = baseUrl;
		global.ServerUrl = baseUrl;
		global.BaseFileUrl = baseFileUrl;
		global.TemplateUrl = templateUrl;
		let userToken = localStorage.getItem('token');
		if (userToken) {
			window.token = userToken;
		}
		let userRole = localStorage.getItem('USER_ROLE');
		if (userRole) {
			global.UserRole = JSON.parse(userRole);
		}
		this.getBaseInfo();
		this.connectWs();
		setInterval(() => {
			this.sendHeartbeat();
		}, 30 * 1000)

		window.onbeforeunload = (e) => {
			// 即将离开当前页面（刷新或关闭）
			console.log('onbeforeunload');
			if (global.loginUser && global.loginUser._id) {
				this.sendMsg({ code: 'QUIT', account: global.loginUser._id, token: window.token })
			}
		}
	}
	getBaseInfo = () => {
		this.loadUserRole();
		this.loadCourseType();
		this.loadPackages();
		this.loadAllUser((res) => {
			global.users = res;
		});
		this.getConf();
	};

	loadUserRole = () => {
		DataStore.loadAll('Dict').then(res => {
			res = res || [];
			for (let i = 0; i < res.length; i++) {
				if (res[i].code === 'USER_ROLE') {
					global.UserRole = res[i].items;
					localStorage.setItem("USER_ROLE", JSON.stringify(global.UserRole));
				}
			}
		});
	};

	loadCourseType = () => {
		DataStore.loadAll('CourseType').then(res => {
			res = res || [];
			global.courseTypes = res;
		});
	};

	loadPackages = () => {
		DataStore.loadAll('Package').then(res => {
			res = res || [];
			res.sort((a, b) => {
				return a.lessonType - b.lessonType;
			});
			global.packageList = res;
		});
	};

	loadCourses = () => {
		DataStore.loadAll("Course").then(res => {
			res = res || [];
			res.sort((a, b) => {
				return a.name.localeCompare(b.name, 'zh-CN');
			});
			global.courseList = res;
		})
	};

	loadAllUser = (callback) => {
		DataStore.loadAll('User').then(res => {
			res = res || [];
			if (callback) {
				callback(res);
			}
		});
	};

	getConf = () => {
		let url = global.ServerUrl + 'conf';
		Net.get(url, (res) => {
			console.log("getConf", res)
			global.conf = res.ret || config.conf || {};
			this.getConfig();
		}, error => {
			console.log("getConf", error)
			global.conf = config.conf || {};
			this.getConfig();
		});
	};

	getConfig = () => {
		let url = global.ServerUrl + 'config';
		Net.get(url, (res) => {
			console.log("getConfig", res)
			global.conf = res.ret || config.conf || {};
		}, error => {
			console.log("getConfig", error)
			global.conf = config.conf || {};
		});
	};

	goToLogin = () => {
		console.log(window.location.pathname);
		clearRemember();
		let rememberMe = getRemember();
		if (rememberMe) {
			clearRememberUser();
		}
		let url = global.delParam("token");
		window.location.href = url + '/#/login';
	};

	sendHeartbeat() {
		if (!global.loginUser)
			return;
		try {
			if (global.ws && global.ws.readyState === global.ws.OPEN) {
				global.ws.send(JSON.stringify({ code: "HEARTBEAT", account: global.loginUser._id }));
			} else if (global.ws == null) {
				this.connectWs();
			} else {
				if (global.ws.readyState === 0)
					connectingTime++;
				if (connectingTime === 3) {
					connectingTime = 0;
					global.ws = null;
					this.connectWs();
				}
			}
		} catch (e) {
			this.connectWs();
		}
	}
	connectWs = () => {
		if (!global.loginUser)
			return;
		const baseUrl = global.isDev ? config.websocketUri.dev : config.websocketUri.pro;
		if (global.ws) {
			global.ws.onopen = null;
			global.ws.onerror = null;
			global.ws.onclose = null;
			global.ws.close();
		}
		global.ws = new WebSocket("wss://" + baseUrl + "/websocket");
		global.ws.onopen = (e) => {
			this.delay = 0;
			//成功连接服务器回调
			console.log('客户端（client）：与服务器的连接已打开', e);
			global.reconnect && clearInterval(global.reconnect);
			if (global.loginUser && global.loginUser._id) {
				this.sendMsg({ code: 'JOIN', account: global.loginUser._id, token: window.token })
			}
		};
		global.ws.onmessage = (message) => {
			//成功连接服务器回调
			if (message) {
				let data = JSON.parse(message.data);
				if (data.code === 'CALL' || data.code === 'AGREE' || data.code === 'REFUSE' || data.code === 'NOREPLY' || data.code === 'EXIT') {
					console.log('connectWs data', data)
					global.receiveCall && global.receiveCall(data);
				}
			}
		};
		global.ws.onerror = (e) => {
			setTimeout(() => {
				if (global.ws.readyState != global.ws.OPEN)
					this.connectWs();
			}, 2000);
			this.delay += 5000;
			if (this.delay > 60000)
				this.delay = 5000;
			setTimeout(() => {
				if (global.ws.readyState != global.ws.OPEN)
					this.connectWs();
				if (process.env.NODE_ENV !== 'development') {
					console.log("ws.onerror", e);
				}
			}, this.delay);
		};
		global.ws.onclose = (e) => {
			global.ws.onerror(e);
			// this.delay += 5000;
			// if (this.delay > 60000)
			//     this.delay = 5000;
			// if(global.ws && global.ws.readyState!==1) {
			//     setTimeout(() => {
			//         this.connectWs();
			//         console.log('global.reconnect');
			//     }, this.delay);
			// }
		};
	}
	sendMsg = (msg) => {
		if (global.ws && global.ws.send && global.ws.readyState !== 0) {
			try {
				global.ws.send(JSON.stringify(msg));
			} catch (error) {
				console.log("app global.ws.send", error)
			}
		}
	};

	render() {
		return (
			<Router>
				<Switch>
					<Route path="/login" component={Login} />
					<PrivateRoute path="/sys" component={Routes} />
					<Redirect exact from="/" to="/login" />
				</Switch>
			</Router>
		)
	}
}

export default App;
